module.exports = __webpack_public_path__ + "static/hinawbg-a714f095f4e6ae1768409b83cf254e25.png";